import { inject, Injectable } from '@angular/core';
import { QsHttpService } from '../core/http/qs-http.service';
import { Observable } from 'rxjs';
import { IDataPayloadSingle } from '../core/http/http.interface';
import { TGsaInfo } from './gsa-info.interface';

@Injectable({
  providedIn: 'root',
})
export class GsaInfoService {
  protected readonly _http: QsHttpService = inject(QsHttpService);

  public getGsaInfoContent(): Observable<IDataPayloadSingle<TGsaInfo>> {
    const params = [
      `populate=${[
        'gsa.background_color',
        'gsa.background_image',
        'gsa.main_image',
        'gsa.logo',
        'gsa.ctas',
        'gsa.theme',
        'gsa.description',
        'gsa.app_icons.icons.image',
        'gsa.bottom_image',
        'gsa.cards.cover_image',
        'gsa.green_checkmarks',
        'gsa.bullets',
        'gsa.videos',
        'gsa.image',
        'seo.metaImage',
      ].join(',')}`,
    ];

    return this._http.get(`/gsa-info-page?${params.join('&')}`);
  }
}
